import httpClient from "Api/httpClient";

const END_POINT = "/subscriptions";
const SUBSCRIPTION_RENEWAL_ENDPOINT = "/subscription_renewals";

const getSubscriptions = (payload) => {
	let body = "";
	if (payload.body) body = payload.body;
	if (payload.device_subscriptions === true) {
		return httpClient.get(END_POINT + "/devices_without_subscription", { retryTimes: 3, params: body });
	} else {
		return httpClient.get(END_POINT, { retryTimes: 3, params: body });
	}
};

const getSubscription = (subscription_id) => {
	if (!subscription_id) return;
	const SINGLE_END_POINT = END_POINT + "/" + subscription_id;
	return httpClient.get(SINGLE_END_POINT);
};

const printSubscription = (subscription_id) => {
	if (!subscription_id) return;
	const SINGLE_END_POINT = END_POINT + "/print?subscription_id=" + subscription_id;
	return httpClient.get(SINGLE_END_POINT);
};

const createSubscriptions = (payload) => {
	let body = "";
	if (payload.body) body = JSON.stringify(payload.body);
	return httpClient.post(END_POINT, body);
};

const updateSubscriptions = (payload, subscription_id) => {
	let body = "";
	if (payload.body) body = JSON.stringify(payload.body);
	const UPDATE_END_POINT = END_POINT + "/" + subscription_id;
	return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteSubscriptions = (subscription_id) => {
	const DELETE_END_POINT = END_POINT + "/" + subscription_id;
	return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const getKanban = (payload) => {
	let body = "";
	if (payload.body) body = payload.body;
	if (payload.kanban === true) {
		return httpClient.get("/subscription_renewals/kanban", { retryTimes: 3, params: body });
	} else {
		return httpClient.get(END_POINT, { retryTimes: 3, params: body });
	}
};

const getSubscriptionRenewal = (renewal_period_id) => {
	if (!renewal_period_id) return;
	const SINGLE_END_POINT = SUBSCRIPTION_RENEWAL_ENDPOINT + "/" + renewal_period_id;
	return httpClient.get(SINGLE_END_POINT);
};

const updateSubscriptionRenewalSelections = (renewal_period_id, payload) => {
	if (!renewal_period_id) return;

	var body = payload ? JSON.stringify(payload) : JSON.stringify({ selections: [] });
	var UPDATE_END_POINT = SUBSCRIPTION_RENEWAL_ENDPOINT + "/" + renewal_period_id;

	return httpClient.patch(UPDATE_END_POINT, body);
};

const confirmSubscriptionRenewal = (renewal_period_id, payload) => {
	if (!renewal_period_id) return;

	var body = payload ? JSON.stringify(payload) : JSON.stringify({ selections: [] });
	var END_POINT = SUBSCRIPTION_RENEWAL_ENDPOINT + "/" + renewal_period_id + "/confirm";

	return httpClient.post(END_POINT, body);
};

const createSubscriptionRenewalInvoice = (renewal_period_id, payload) => {
	if (!renewal_period_id) return;

	var body = payload ? JSON.stringify(payload) : JSON.stringify({ renewal_item_ids: [] });
	var END_POINT = SUBSCRIPTION_RENEWAL_ENDPOINT + "/" + renewal_period_id + "/invoice";

	return httpClient.post(END_POINT, body);
};

const voidSubscriptionInvoice = (invoice_id, payload) => {
	if (!invoice_id) return;

	var body = payload ? JSON.stringify(payload) : JSON.stringify({ reason: "" });
	var END_POINT = "/subscription_invoices/" + invoice_id + "/void";

	return httpClient.post(END_POINT, body);
};

const getSubscriptionInvoicePdf = (invoice_id) => {
	if (!invoice_id) return;
	const END_POINT = "/subscription_invoices/" + invoice_id + "/pdf";
	return httpClient.get(END_POINT, { retryTimes: 3 });
};

const syncSubscriptionInvoiceToZoho = (invoice_id, force) => {
	if (!invoice_id) return;
	var END_POINT = "/subscription_test/sync_invoice?invoice_id=" + invoice_id;
	if (force) END_POINT += "&force=" + force;
	return httpClient.get(END_POINT, JSON.stringify({}));
};

export {
	getSubscriptions,
	getSubscription,
	printSubscription,
	createSubscriptions,
	updateSubscriptions,
	deleteSubscriptions,
	getKanban,
	getSubscriptionRenewal,
	updateSubscriptionRenewalSelections,
	confirmSubscriptionRenewal,
	createSubscriptionRenewalInvoice,
	voidSubscriptionInvoice,
	getSubscriptionInvoicePdf,
	syncSubscriptionInvoiceToZoho,
};
